export default __webpack_public_path__ + "static/buyers-edge-banner-251a533434aa466f3d9c83f780ab1a51.webp";